
      // Configuração mais avançada do service worker
      if ('serviceWorker' in navigator) {
        window.addEventListener('load', async () => {
          try {
            const registration = await navigator.serviceWorker.register('/sw.js', {
              scope: '/'
            });
            
            // Verificar atualizações do service worker periodicamente
            setInterval(() => {
              registration.update();
            }, 1000 * 60 * 60); // Verificar a cada hora
            
            // Configurar sincronização em segundo plano
            if ('SyncManager' in window) {
              registration.sync.register('sync-data');
            }
            
            // Configurar sincronização periódica (se suportado)
            if ('periodicSync' in registration) {
              try {
                await registration.periodicSync.register('update-content', {
                  minInterval: 24 * 60 * 60 * 1000, // Uma vez por dia
                });
              } catch (error) {
                console.log('Periodic sync could not be registered:', error);
              }
            }
            
            console.log('Service Worker registrado com sucesso:', registration.scope);
          } catch (error) {
            console.error('Falha no registro do Service Worker:', error);
          }
        });
        
        // Lidar com atualizações do service worker
        let refreshing = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (refreshing) return;
          refreshing = true;
          window.location.reload();
        });
      }
      
      // Implementar cache local com IndexedDB para dados frequentes
      const initLocalCache = async () => {
        if (!('indexedDB' in window)) return;
        
        try {
          const dbName = 'paraisoBordadosCache';
          const request = indexedDB.open(dbName, 1);
          
          request.onupgradeneeded = (event) => {
            const db = event.target.result;
            
            // Criar stores para diferentes tipos de dados
            if (!db.objectStoreNames.contains('products')) {
              db.createObjectStore('products', { keyPath: 'id' });
            }
            
            if (!db.objectStoreNames.contains('categories')) {
              db.createObjectStore('categories', { keyPath: 'id' });
            }
            
            if (!db.objectStoreNames.contains('settings')) {
              db.createObjectStore('settings', { keyPath: 'key' });
            }
          };
          
          request.onsuccess = (event) => {
            console.log('IndexedDB inicializado com sucesso');
            // Aqui você pode adicionar lógica para pré-carregar dados importantes
          };
          
          request.onerror = (event) => {
            console.error('Erro ao inicializar IndexedDB:', event.target.error);
          };
        } catch (error) {
          console.error('Erro ao configurar cache local:', error);
        }
      };
      
      // Iniciar cache local
      initLocalCache();
      
      // Adicionar analytics de forma otimizada
      const addAnalytics = () => {
        if (window.location.hostname !== 'localhost') {
          // Implementação futura de analytics
          // Usando requestIdleCallback para não afetar performance
          if ('requestIdleCallback' in window) {
            window.requestIdleCallback(() => {
              // Código de analytics aqui
            }, { timeout: 5000 });
          } else {
            setTimeout(() => {
              // Fallback para browsers sem requestIdleCallback
              // Código de analytics aqui
            }, 5000);
          }
        }
      };
      
      // Adicionar analytics com baixa prioridade
      addAnalytics();
      
      // Monitor de performance
      if ('performance' in window && 'PerformanceObserver' in window) {
        // Monitorar Web Vitals
        const observer = new PerformanceObserver((list) => {
          for (const entry of list.getEntries()) {
            // Registrar métricas importantes
            console.log(`[Performance] ${entry.name}: ${entry.startTime.toFixed(0)}ms`);
          }
        });
        
        // Observar métricas de performance diferentes
        observer.observe({ entryTypes: ['largest-contentful-paint', 'first-input', 'layout-shift'] });
      }
    